"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Li = exports.Ul = exports.Title = exports.titleStyles = exports.Wrap = exports.Selector = exports.List = void 0;
const app_1 = require("@obvio/app");
exports.List = app_1.styled.div `
  @media ${app_1.notDesktop} {
    display: none;
  }
`;
exports.Selector = app_1.styled.div `
  width: 100%;
  @media ${app_1.desktop} {
    display: none;
  }
`;
exports.Wrap = app_1.styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
`;
exports.titleStyles = (0, app_1.css) `
  font-weight: bold;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.175rem;
  ${app_1.styled.current `
    font-weight: 700;
  `}
`;
exports.Title = (0, app_1.styled)(app_1.Link) `
  display: block;
  ${exports.titleStyles}
`;
exports.Ul = app_1.styled.ul `
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
`;
exports.Li = app_1.styled.li `
  a {
    font-weight: ${(_t, { $active }) => ($active ? 'bold' : 500)};
    font-size: 0.8125rem;
  }
`;
